export const getFeaturesByProductLine = ({
  features
}, {
  productLine
}) => {
  if (!features || !Object.keys(features).length) return [];
  return features.features[productLine] || [];
};
export const getAllFeaturesByAllProductLines = ({
  features
}) => {
  if (!features || !Object.keys(features).length) return {};
  return features.features;
};

const areEqual = (array1, array2) => {
  if (array1.length === array2.length) {
    return array1.every(element => {
      if (array2.includes(element)) {
        return true;
      }

      return false;
    });
  }

  return false;
};

export const hasFeaturesForProductLineAndHighlights = ({
  features
}, {
  productLine,
  highlightedProducts
}) => {
  const productsInState = features && features.highlightedProducts && features.highlightedProducts[productLine] || [];

  if (!features || !productsInState.length) {
    return false;
  }

  return areEqual(highlightedProducts, productsInState);
};